import * as React from "react";
import Slider from "rc-slider";
import { isArray } from "@grandvisionhq/utils";
import Price from "../../Price/Price/Price.js";
/* empty css                 */
const TooltipLabel = ({ currency, renderNumber, value, side }) => /* @__PURE__ */ React.createElement("div", { className: `tooltip__label tooltip__label--${side}`, "data-t": `tooltip-label-${side}` }, currency ? /* @__PURE__ */ React.createElement(Price, { value: renderNumber(value), currency, centAmount: false }) : renderNumber(value));
const defaultValueInitial = [];
const renderNumberInitial = (v) => v;
const RangeSlider = ({
  min,
  max,
  defaultValue = defaultValueInitial,
  value,
  onChange,
  onChangeComplete,
  currency,
  renderNumber = renderNumberInitial
}) => {
  const handleOnChange = (value2) => {
    if (!isArray(value2)) return;
    onChange?.(value2);
  };
  const handleOnChangeComplete = (value2) => {
    if (!isArray(value2)) return;
    onChangeComplete?.(value2);
  };
  return /* @__PURE__ */ React.createElement("div", { className: "range-slider", "data-t": "range-slider" }, /* @__PURE__ */ React.createElement(
    Slider,
    {
      ...value ? { value } : { defaultValue },
      range: true,
      min,
      max,
      onChangeComplete: handleOnChangeComplete,
      onChange: handleOnChange,
      allowCross: false
    }
  ), /* @__PURE__ */ React.createElement("div", { className: "tooltip" }, /* @__PURE__ */ React.createElement(
    TooltipLabel,
    {
      currency,
      value: (value || defaultValue)[0],
      renderNumber,
      side: "left"
    }
  ), /* @__PURE__ */ React.createElement(
    TooltipLabel,
    {
      currency,
      value: (value || defaultValue)[1],
      renderNumber,
      side: "right"
    }
  )));
};
export {
  RangeSlider
};
//# sourceMappingURL=RangeSlider.js.map
